import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FiltersetResource } from './getFilter.component';

export interface SelectResourceDialogData {
  title: string;
  listHeaderText: string;
  availableResources: FiltersetResource[];
  onResourceSelected?: (resource: FiltersetResource) => void;
}

@Component({
    selector: 'app-select-resource-dialog',
    templateUrl: './select-resource-dialog.component.html',
    styleUrls: ['./select-resource-dialog.component.scss'],
    standalone: false
})
export class SelectResourceDialogComponent implements OnInit {
  filterText = '';

  constructor(
    public dialogRef: MatDialogRef<SelectResourceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectResourceDialogData
  ) { }

  ngOnInit(): void {
    // Initialize
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  selectResource(resource: FiltersetResource): void {
    // Remove from available resources
    const index = this.data.availableResources.findIndex(r => r.resourceId === resource.resourceId);
    if (index >= 0) {
      this.data.availableResources.splice(index, 1);
    }

    // Notify parent component
    if (this.data.onResourceSelected) {
      this.data.onResourceSelected(resource);
    }

    if(this.data.availableResources.length === 0) {
      this.dialogRef.close();
    }
  }

  decodeHtmlEntities(text: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    return doc.documentElement.textContent || '';
  }

  get filteredResources(): FiltersetResource[] {
    if (!this.filterText) {
      return this.data.availableResources || [];
    }
    const filter = this.filterText.toLowerCase();
    return (this.data.availableResources || []).filter(r =>
      (r.description || '').toLowerCase().includes(filter)
    );
  }
}

